<nz-slider
  [nzMin]="min"
  [nzMax]="max"
  [nzStep]="step"
  [nzMarks]="marks"
  [nzDots]="dots"
  [nzDisabled]="disabled"
  [nzTooltipVisible]="'never'"
  [formControl]="control"
></nz-slider>
